import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { translate } from './translateFunction';
import './UserRequest.css'; // Verwende die CSS-Datei für den Ladebalken

const TeamRequest = ({ selectedTeam, selectedUser }) => {
  const [requests, setRequests] = useState([]);
  const [activeRow, setActiveRow] = useState(null);
  const [showProgressBar, setShowProgressBar] = useState(false);

  const [translations, setTranslations] = useState({
    teamRequestsTitle: '',
    sentOn: '',
    createdBy: '',
    customer: '',
    contactPerson: '',
    actions: '',
    noRequestsFound: '',
    sendReminder: '',
  });

  useEffect(() => {
    const loadTranslations = async () => {
      const teamRequestsTitle = await translate(30); // "Team Feedback Requests"
      const sentOn = await translate(31); // "Gesendet am"
      const createdBy = await translate(32); // "Ersteller"
      const customer = await translate(33); // "Kunde"
      const contactPerson = await translate(34); // "Kontaktperson"
      const actions = await translate(35); // "Aktionen"
      const noRequestsFound = await translate(36); // "Keine Feedback-Anfragen gefunden."
      const sendReminder = await translate(37); // "Erinnerung senden"

      setTranslations({
        teamRequestsTitle,
        sentOn,
        createdBy,
        customer,
        contactPerson,
        actions,
        noRequestsFound,
        sendReminder,
      });
    };

    loadTranslations();
  }, []);

  useEffect(() => {
    const fetchTeamRequests = async () => {
      const token = localStorage.getItem('token');
      const teamId = selectedTeam === 'all' ? 'all' : selectedTeam;

      if (selectedTeam) {
        try {
          const url =
            selectedUser && selectedUser !== 'all'
              ? `/api/team/requests/${teamId}/${selectedUser}`
              : `/api/team/requests/${teamId}`;

          const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });

          setRequests(response.data || []);
        } catch (error) {
          console.error('Fehler beim Abrufen der Team-Requests:', error);
          setRequests([]);
        }
      }
    };

    fetchTeamRequests();
  }, [selectedTeam, selectedUser]);

  const handleRemind = async (request) => {
    setShowProgressBar(true);
    setActiveRow(request.customerFdbckID);

    try {
      // Der Server schickt den Reminder an den Ersteller der Anfrage
      await axios.post(`/api/customerFeedback/${request.customerFdbckID}/reminder`);

      alert('Reminder email sent successfully.');
    } catch (error) {
      console.error('Error sending reminder email:', error);
      alert('Failed to send reminder email.');
    } finally {
      setTimeout(() => {
        setShowProgressBar(false);
        setActiveRow(null);
      }, 2000);
    }
  };

  return (
    <div className="mb-5">
      {showProgressBar && <div className="progress-bar"></div>}
      <h3>{translations.teamRequestsTitle}</h3>
      <table className="table">
        <thead>
          <tr>
            <th>{translations.sentOn}</th>
            <th>{translations.createdBy}</th>
            <th>{translations.customer}</th>
            <th>{translations.contactPerson}</th>
            <th>{translations.actions}</th>
          </tr>
        </thead>
        <tbody>
          {requests.length > 0 ? (
            requests.map((request, index) => {
              const previousRequest = requests[index - 1];
              const currentYear = new Date(request.customerFdbckSend).getFullYear();
              const previousYear = previousRequest
                ? new Date(previousRequest.customerFdbckSend).getFullYear()
                : currentYear;
              const isNewYear = previousRequest && currentYear < previousYear;

              return (
                <React.Fragment key={request.customerFdbckID}>
                  {isNewYear && <tr className="year-separator"></tr>}
                  <tr
                    className={activeRow === request.customerFdbckID ? 'active' : ''}
                  >
                    <td>{new Date(request.customerFdbckSend).toLocaleDateString("fr-CH")}</td>
                    <td>{request.usersName}</td>
                    <td>{request.customerCompany}</td>
                    <td>{request.customerName}</td>
                    <td>
                      <button
                        className="btn btn-primary"
                        onClick={() => handleRemind(request)}
                      >
                        {translations.sendReminder}
                      </button>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="5">{translations.noRequestsFound}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TeamRequest;
